module.exports = __webpack_public_path__ + "img/rediger.45b37cbe.svg";